export const ALL = 'ALL';
export const COMMON = 'Common';
export const UNCOMMON = 'Uncommon';
export const RARE = 'Rare';
export const EPIC = 'Epic';
export const LEGENDARY = 'Legendary';
